import { SelfPacedHomeWorkRow } from "components/molecules/SelfPacedHomeWorkRow";
import { DrillSmartModal, RefreshModal } from "components/molecules";
import { useState } from "react";
import { DrillPaginationTab } from "./DrillPaginationTab";
import { UnlockModal } from "./UnlockModal";
import { useAppDispatch, useScreenSize } from "hooks";
import { openIframeModal } from "state/reducers/layoutSlice";
import {
  CONTENT_OBJECT_TYPE_ID,
  MCAT_TEST_TYPE,
  MOBILE_WIDTH,
} from "utils/constants";
import { useNavigate } from "react-router-dom";
import { DrillModal } from "../TabClassHomeWork";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import {
  replaceSelfPacedArrayOfObjects,
  reStructureSelfPacedSegment,
} from "utils/functions/selfPacedCourseWorkRestructure";
import { decodeToken } from "utils/functions/decodeToken";
import {
  homeApi,
  useGetOverallProgressQuery,
  useGetTestScoresAndPerformanceQuery,
  useLazyGetCourseworkQuery,
} from "services/homeApi";
import { useLazyGetCourseIndexQuery } from "services/courseIndex";
import { useSegmentReFetch } from "context";
import { useLazyGetAiRecommendationsQuery } from "services/aiRecommendations";
import "./index.scss";
import { openExternalUrl } from "utils/functions/openExternalUrl";
import { addShowAITriggerToScoreReportUrl } from "utils/functions/addShowAITriggerToScoreReportUrl";
import { getDrillSmartOnStartDrill } from "utils/functions/getDrillSmartOnStartDrill";
import type { DrillSmartModalData } from "utils/functions/drillSmart";

interface IProps {
  isBtn?: boolean;
  isSecondBtn?: boolean;
  secondBtnLabel?: string;
  exams: any;
  type: any;
  theme: "light" | "dark";
  itemPageNo?: number;
}

export const SelfPacedHomeworkTab = ({
  isSecondBtn,
  secondBtnLabel,
  isBtn,
  exams,
  type,
  theme,
  itemPageNo,
}: IProps) => {

  const [isRefreshModalOpen, setIsRefreshModalOpen] = useState<any>({
    isOpen: false,
    ContentObjectType: null,
  });

  const [toggleUnlockModal, settoggleUnlockModal] = useState(false);

  const [toggleDrillSmart, setToggleDrillSmart] = useState<{
    isOpen: boolean;
    data:
      | ""
      | {
          content: any;
          drillSmartResult: any;
          drillSmartLaunchUrl: any;
          groupName: string;
          nextDrill: any;
        };
  }>({
    isOpen: false,
    data: "",
  });

  const [openUpdateModalState, setOpenUpdateModalState] = useState<any>({
    isOpen: false,
    data: null,
  });

  const { data, setData, subject } = useSegmentReFetch();

  const screen = useScreenSize();

  const navigate = useNavigate();

  const payload = decodeToken();

  const dispatch = useAppDispatch();

  const userId = payload ? payload.userid : null;
  const productCode = payload ? payload.productcode : null;
  const offeringCode = payload ? payload.offeringcode : null;

  const testtype =
    payload && payload.hasOwnProperty("testtype") && payload.testtype;

  const isMCAT = testtype === MCAT_TEST_TYPE;

  const [triggerRefetchCoursework, courseworkRefetchResult] =
    useLazyGetCourseworkQuery();

  const { refetch: testScoresRefetch, isFetching: testScoresIsFetching } =
    useGetTestScoresAndPerformanceQuery();

  const [triggerCourseIndexRefetch, courseIndexRefetchResult] =
    useLazyGetCourseIndexQuery();

  const {
    refetch: overAllProgressRefetch,
    isFetching: overallProgressIsFetching,
  } = useGetOverallProgressQuery({
    Userid: userId,
    Productcode: productCode,
    Offeringcode: offeringCode,
  });

  const [
    triggerRefetchAiRecommendation,
    aiRecommendationRefetchResult,
  ] = useLazyGetAiRecommendationsQuery();

  const handleRefreshModalClose = () => {
    setIsRefreshModalOpen((prev: any) => ({
      ...prev,
      isOpen: false,
      ContentObjectType: null,
    }));
  };

  const handleUpdateModalClose = () => {
    setOpenUpdateModalState((prev: any) => ({
      ...prev,
      isOpen: false,
      data: null,
    }));
  };

  const handleUpgradeCourse = () => {
    if (payload && payload.hasOwnProperty("freeToPaidUpgradeLink")) {
      window.open(payload.freeToPaidUpgradeLink, "__blank");
      setTimeout(() => {
        settoggleUnlockModal(false);
        setIsRefreshModalOpen((prev: any) => ({
          ...prev,
          isOpen: true,
          ContentObjectType: "Purchase",
        }));
      }, 500)
    }
  };

  const handlePrimaryBtnClick = (value: any, type?: string) => {
    // Check if this is a DrillSmartGrouping object (either from type or _isDrillSmartGrouping flag)
    if (type === "DrillSmartContent" || value._isDrillSmartGrouping === true) {
      // Check if DrillSmartGrouping is locked
      if (value.IsLocked === true) {
        if (screen.width <= MOBILE_WIDTH) {
          navigate("/self-paced/unlock");
        } else {
          settoggleUnlockModal(true);
        }
        return;
      }
      
      const modalData : any = {
        content: value.Content, 
        drillSmartResult: value.DrillSmartResult, 
        drillSmartLaunchUrl: value.LaunchUrl,
        groupName: value.GroupName,
        nextDrill: value.NextDrill,
        isLocked: value.IsLocked === true
      };

      setToggleDrillSmart((prev) => ({ 
        ...prev,
        data: modalData,
        isOpen: true
      }));
    } else if (value.Status === "Lock" || value.IsLocked === true) {

      if (screen.width <= MOBILE_WIDTH) {
        navigate("/self-paced/unlock");
      } else {
        settoggleUnlockModal(true);
      }
    } else {
      if (
        value.ContentObjectTypeId === CONTENT_OBJECT_TYPE_ID.OfflineDrill ||
        value.ContentObjectTypeId === CONTENT_OBJECT_TYPE_ID.OfflineReading
      ) {
        setOpenUpdateModalState((prev: any) => ({
          ...prev,
          isOpen: true,
          data: {
            ...value,
            ...(value.ContentObjectGuid === undefined && {
              ContentObjectGuid: value.Guid,
            }),
            ContentObjectType: Object.keys(CONTENT_OBJECT_TYPE_ID).find(
              (key: string) =>
                CONTENT_OBJECT_TYPE_ID[key] === value.ContentObjectTypeId
            ),
          },
        }));
      } else {
        const contentType = Object.keys(CONTENT_OBJECT_TYPE_ID).find(
          (key: string) =>
            CONTENT_OBJECT_TYPE_ID[key] === value.ContentObjectTypeId
        );
        openExternalUrl({
          url: value.LaunchUrl,
          contentObjectType: contentType,
          testType: testtype,
          dispatch,
          onRefreshModalOpen: (contentType) => {
            setIsRefreshModalOpen((prev: any) => ({
              ...prev,
              isOpen: true,
              ContentObjectType: value.ContentObjectType || Object.keys(CONTENT_OBJECT_TYPE_ID).find(
                (key: string) =>
                  CONTENT_OBJECT_TYPE_ID[key] === value.ContentObjectTypeId
              ) || "lesson",
            }));
          },
        });
      }
    }
  };

  const handleSecondaryBtnClick = (value: any) => {
    // Only show iframe modal for MCAT test type
    if (isMCAT) {
      dispatch(openIframeModal({
        url: value.ScoreReportUrl,
        title: 'Score Report'
      }));
    } else {
      // For non-MCAT, open in new tab
      window.open(addShowAITriggerToScoreReportUrl(value.ScoreReportUrl), "__blank");
    }
  };

  const handleRefreshStatus = async () => {
    // Invalidate cache tags IMMEDIATELY so other pages/components start refetching
    // This marks all Coursework queries as stale, triggering automatic refetches on subscribed queries
    dispatch(homeApi.util.invalidateTags(["Coursework", "Practice"]));
    const promises = [
      triggerRefetchCoursework({
        page: itemPageNo ? itemPageNo : 1,
        ...(testtype === MCAT_TEST_TYPE ? { subject: subject } : {}),
      }),
      triggerCourseIndexRefetch(),
      overAllProgressRefetch(),
      testScoresRefetch(),
      triggerRefetchAiRecommendation()
    ];
    Promise.allSettled(promises).then((responses: any) => {
      handleRefreshModalClose();
      let updatedArray: any[] | undefined;
      if (responses[0].status === "fulfilled") {
        try {
          const deStructuredArray = reStructureSelfPacedSegment(
            responses[0].value.data
          );
          updatedArray = replaceSelfPacedArrayOfObjects(
            deStructuredArray,
            data
          );
          if (
            updatedArray &&
            (responses[1].status === "fulfilled" ||
              responses[2].status === "fulfilled" ||
              responses[3].status === "fulfilled")
          ) {
            setData([...updatedArray]);
          }
        } catch (_) {
          // keep modal closed; data update failed
        }
      }

      const drillSmartData = toggleDrillSmart.data;
      const groupName =
        typeof drillSmartData === "object" && drillSmartData && "groupName" in drillSmartData
          ? (drillSmartData as { groupName: string }).groupName
          : null;
      if (toggleDrillSmart.isOpen && groupName && updatedArray) {
        for (const track of updatedArray) {
          for (const group of track.Groups || []) {
            const drillGroup = (group.DrillSmartGrouping || []).find(
              (dg: any) => dg.GroupName === groupName
            );
            if (drillGroup) {
              const modalData = {
                content: drillGroup.Content,
                drillSmartResult: drillGroup.DrillSmartResult,
                drillSmartLaunchUrl: drillGroup.LaunchUrl,
                groupName: drillGroup.GroupName,
                nextDrill: drillGroup.NextDrill,
                isLocked: drillGroup.IsLocked === true,
              };
              setToggleDrillSmart((prev) => ({ ...prev, data: modalData }));
              break;
            }
          }
        }
      }
    });
  };

  return (
    <>
      {exams && Array.isArray(exams) && exams.length > 5 ? (
        <DrillPaginationTab
          exams={exams}
          theme={theme}
          type={type}
          settoggleUnlockModal={settoggleUnlockModal}
          handlePrimaryBtnClick={handlePrimaryBtnClick}
          handleSecondaryBtnClick={handleSecondaryBtnClick}
        />
      ) : (
        exams &&
        Array.isArray(exams) &&
        exams.length > 0 &&
        exams.map((value: any, index: number) => {
          // Check if this is a DrillSmartGrouping object
          const isDrillSmartGrouping = type === "DrillSmartContent" || value._isDrillSmartGrouping === true;
          
          return (
            <div className="self-paced-courseowrk-class-container" key={index}>
              <SelfPacedHomeWorkRow
                index={index}
                textIconLabel={isDrillSmartGrouping ? value.GroupName : value.Name}
                badge={isDrillSmartGrouping ? "DrillSmart" : ""}
                iconType={
                  isDrillSmartGrouping
                    ? (() => {
                        // Check if DrillSmartGrouping is locked first
                        if (value.IsLocked === true) {
                          return "lock";
                        }
                        // Use DrillSmartResult status for icon
                        const drillSmartStatus = value.DrillSmartResult?.Status || "NotStarted";
                        if (drillSmartStatus === "Completed" || drillSmartStatus === "Complete") {
                          return "select";
                        } else if (drillSmartStatus === "InProgress" || drillSmartStatus === "In Progress") {
                          return "yellow-timer";
                        } else {
                          return "empty-circle";
                        }
                      })()
                    : value.Status === "Lock" || value.IsLocked === true
                      ? "lock"
                      : value.Status === "Not Started"
                        ? "empty-circle"
                        : value.Status === "Completed"
                          ? "select"
                          : "yellow-timer"
                }
                middleLabel={
                  isDrillSmartGrouping
                    ? (() => {
                        // Use DrillSmartResult status for label (preserve actual status even when locked)
                        const drillSmartStatus = value.DrillSmartResult?.Status || "NotStarted";
                        if (drillSmartStatus === "Completed" || drillSmartStatus === "Complete") {
                          return "Completed";
                        } else if (drillSmartStatus === "InProgress" || drillSmartStatus === "In Progress") {
                          return "In Progress";
                        } else {
                          return "Not Started";
                        }
                      })()
                    : value.Status === "Completed"
                      ? `Completed on ${formatToLocalDate(value.DateCompleted, "MM/DD/YYYY")}`
                      : value.Status === "Not Started"
                        ? "Not Started"
                        : value.Status === "Lock"
                          ? "Locked"
                          : "In Progress"
                }
              handlePrimaryBtnClick={() => handlePrimaryBtnClick(value, type)}
              handleSecondaryBtnClick={() => handleSecondaryBtnClick(value)}
              status={isDrillSmartGrouping ? "InProgress" : value.Status}
              isLocked={value.IsLocked}
              contentObjectType={
                  isDrillSmartGrouping
                    ? "DrillSmart"
                    : value.ContentObjectType === undefined
                      ? "Video"
                      : value.ContentObjectType
                        ? value.ContentObjectType
                        : Object.keys(CONTENT_OBJECT_TYPE_ID).find(
                            (key: string) =>
                              CONTENT_OBJECT_TYPE_ID[key] === value.ContentObjectTypeId
                          )}
              drillSmartResult={isDrillSmartGrouping ? value.DrillSmartResult : undefined}
              theme={theme}
            />
            </div>
          );
        })
      )}

      <DrillSmartModal
        handleOnClose={() => setToggleDrillSmart((prev) => ({ ...prev, isOpen: false }))}
        isOpen={toggleDrillSmart.isOpen}
        theme={theme}
        data={toggleDrillSmart.data}
        onStartDrill={getDrillSmartOnStartDrill(
          toggleDrillSmart.data !== "" && toggleDrillSmart.data != null
            ? (toggleDrillSmart.data as DrillSmartModalData)
            : null,
          (contentType) =>
            setIsRefreshModalOpen((prev: any) => ({
              ...prev,
              isOpen: true,
              ContentObjectType: contentType || "DrillSmart",
            })),
          openExternalUrl,
          dispatch,
          testtype
        )}
      />

      <UnlockModal
        handleUnlockModalClose={() => settoggleUnlockModal(false)}
        handleUpgrade={handleUpgradeCourse}
        unlockModalState={toggleUnlockModal}
        theme={theme}
      />

      <RefreshModal
        isOpen={isRefreshModalOpen.isOpen}
        handleOnClose={handleRefreshModalClose}
        theme={theme}
        contentObjectType={isRefreshModalOpen.ContentObjectType}
        isFetching={
          courseworkRefetchResult.isFetching ||
          courseIndexRefetchResult?.isFetching ||
          testScoresIsFetching ||
          overallProgressIsFetching ||
          aiRecommendationRefetchResult.isFetching
        }
        handleRefresh={handleRefreshStatus}
      />

      <DrillModal
        handleUpdateModalClose={handleUpdateModalClose}
        openUpdateModalState={openUpdateModalState}
        theme={theme}
        refetchData={handleRefreshStatus}
        isFetchingOtherAPIs={
          courseworkRefetchResult.isFetching ||
          courseIndexRefetchResult?.isFetching ||
          testScoresIsFetching ||
          overallProgressIsFetching ||
          aiRecommendationRefetchResult.isFetching
        }
      />
    </>
  );
};
